export default __webpack_public_path__ + "static/media/haustin-photo.cc3a3986.jpg";